export enum DATA_QA_ATTRIBUTES {
	RELATED_CONTENT_CONTAINER = 'sidebar-related-content-wrapper',
	ADDED_ITEMS = 'sidebar-related-content-added-items',
	SUGGESTIONS_TAB = 'sidebar-related-content-suggestions-tab',
	SEARCH_TAB = 'sidebar-related-content-search-tab',
	SEARCH_INPUT = 'sidebar-related-content-search-input',
}
